import type { AssessmentTaskStatus } from "../services/assessment_tasks.types";

export interface AssessmentTaskStatusPresentation {
    label: string;
    tagColor: "warning" | "processing" | "error" | "success";
}

export const ASSESSMENT_TASK_STATUSES: readonly AssessmentTaskStatus[] = [
    "needs_review", "pending_review", "rejected", "approved"
];

export const ASSESSMENT_TASK_STATUS_PRESENTATION: Readonly<Record<AssessmentTaskStatus, AssessmentTaskStatusPresentation>> = {
    needs_review: { label: "Incomplete", tagColor: "warning" },
    pending_review: { label: "Pending Review", tagColor: "processing" },
    rejected: { label: "Rejected", tagColor: "error" },
    approved: { label: "Approved", tagColor: "success" }
};

export function isAssessmentTaskStatus(value: unknown): value is AssessmentTaskStatus {
    return typeof value === "string" && ASSESSMENT_TASK_STATUSES.includes(value as AssessmentTaskStatus);
}

export function assessmentTaskStatusPresentation(status: AssessmentTaskStatus): AssessmentTaskStatusPresentation {
    return ASSESSMENT_TASK_STATUS_PRESENTATION[status];
}
